import {
  ExcalidrawElement,
  PointerType,
  NonDeletedExcalidrawElement,
} from "./types";
import { rotate } from "../math";
import {
  OMIT_SIDES_FOR_MULTIPLE_ELEMENTS,
  getTransformHandlesFromCoords,
  getTransformHandles,
  TransformHandleType,
  TransformHandle,
  MaybeTransformHandleType, ConnectionDirection,
} from "./transformHandles";
import {AppState, Zoom, ElementWithHoverHandle, InteractiveCanvasAppState, ElementWithQuickFlowHandle,} from "../types";
import { Bounds } from "./bounds";
import { MIME_TYPES, QUICKFLOW__TOOLTIP_DELAY } from "../constants";
import { getTooltipDiv, updateTooltipPosition } from "../components/Tooltip";
import { trackEvent } from "../analytics";
import { sceneCoordsToViewportCoords } from "../utils";
import {DEFAULT_QUICKFLOW_SPACING, quickFlowElementsType} from "../renderer/renderScene";
import {isNoteElement} from "../../../../src/utils";
import {isStickyNotesElement, isTextElement} from "./typeChecks";
import {OFFSET} from "./mindMap";
import {hasElementRotate} from "../../../../src/Utility";

export const QUICKFLOW_TOP_IMG = document.createElement("img");
QUICKFLOW_TOP_IMG.src = `data:${MIME_TYPES.svg}, ${encodeURIComponent(
    `<svg t="1714552938107" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1451" width="200" height="200"><path d="M542.72 245.248v615.424c0 8.192-2.900992 15.188992-8.704 20.992s-13.140992 8.704-22.016 8.704-16.212992-2.900992-22.016-8.704-8.704-12.8-8.704-20.992v-615.424l-225.28 239.616c-5.460992 6.144-12.628992 9.216-21.504 9.216s-16.212992-3.243008-22.016-9.728-8.704-14.164992-8.704-23.04 3.072-16.724992 9.216-23.552l277.504-294.912c5.460992-6.144 12.628992-9.216 21.504-9.216s16.043008 3.072 21.504 9.216l277.504 294.912c6.144 6.827008 9.216 14.676992 9.216 23.552s-2.900992 16.555008-8.704 23.04c-5.803008 6.484992-12.971008 9.728-21.504 9.728s-15.872-3.072-22.016-9.216l-225.28-239.616z" p-id="1452"></path></svg>`,
)}`;
export const QUICKFLOW_RIGHT_IMG = document.createElement("img");
QUICKFLOW_RIGHT_IMG.src = `data:${MIME_TYPES.svg}, ${encodeURIComponent(
    `<svg t="1714553220721" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3739" width="200" height="200"><path d="M777.216 479.232H167.936c-9.556992 0-17.408 3.072-23.552 9.216s-9.216 13.995008-9.216 23.552 3.072 17.408 9.216 23.552 13.995008 9.216 23.552 9.216h609.28L537.6 783.36c-6.144 6.827008-9.216 14.676992-9.216 23.552s3.243008 16.555008 9.728 23.04c6.484992 6.484992 14.164992 9.728 23.04 9.728s16.724992-3.072 23.552-9.216l294.912-294.912c6.144-6.827008 9.216-14.676992 9.216-23.552s-3.072-16.724992-9.216-23.552L584.704 193.536c-6.827008-6.144-14.676992-9.216-23.552-9.216s-16.555008 3.243008-23.04 9.728c-6.484992 6.484992-9.728 14.164992-9.728 23.04s3.072 16.724992 9.216 23.552l239.616 238.592z" p-id="3740"></path></svg>`,
)}`;
export const QUICKFLOW_BOTTOM_IMG = document.createElement("img");
QUICKFLOW_BOTTOM_IMG.src = `data:${MIME_TYPES.svg}, ${encodeURIComponent(
    `<svg t="1714553266317" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4037" width="200" height="200"><path d="M544.768 795.648V142.336c0-9.556992-3.072-17.408-9.216-23.552s-13.995008-9.216-23.552-9.216-17.408 3.072-23.552 9.216-9.216 13.995008-9.216 23.552v653.312L240.64 541.696c-6.827008-6.827008-14.676992-10.24-23.552-10.24s-16.555008 3.584-23.04 10.752c-6.484992 7.168-9.728 15.188992-9.728 24.064s3.072 17.067008 9.216 24.576l294.912 313.344c6.827008 6.827008 14.676992 10.24 23.552 10.24s16.724992-3.412992 23.552-10.24l294.912-313.344c6.144-7.508992 9.216-15.700992 9.216-24.576s-3.243008-16.896-9.728-24.064S815.787008 531.456 806.912 531.456s-16.724992 3.412992-23.552 10.24L544.768 795.648z" p-id="4038"></path></svg>`,
)}`;
export const QUICKFLOW_LEFT_IMG = document.createElement("img");
QUICKFLOW_LEFT_IMG.src = `data:${MIME_TYPES.svg}, ${encodeURIComponent(
    `<svg t="1714553239517" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3886" width="200" height="200"><path d="M200.704 479.232h655.36c9.556992 0 17.408 3.072 23.552 9.216s9.216 13.995008 9.216 23.552-3.072 17.408-9.216 23.552-13.995008 9.216-23.552 9.216H200.704c-9.556992 0-17.408-3.072-23.552-9.216s-9.216-13.995008-9.216-23.552 3.072-17.408 9.216-23.552 13.995008-9.216 23.552-9.216z m13.312 32.768l272.384 271.36c6.144 6.827008 9.216 14.676992 9.216 23.552s-3.243008 16.555008-9.728 23.04c-6.484992 6.484992-14.164992 9.728-23.04 9.728s-16.724992-3.072-23.552-9.216L144.384 535.552c-6.144-6.827008-9.216-14.676992-9.216-23.552s3.072-16.724992 9.216-23.552l294.912-294.912c6.827008-6.144 14.676992-9.216 23.552-9.216s16.555008 3.243008 23.04 9.728c6.484992 6.484992 9.728 14.164992 9.728 23.04s-3.072 16.724992-9.216 23.552L214.016 512z" p-id="3887"></path></svg>`,
)}`;
export const QUICKFLOW_MARGIN = 160;

const isInsideTransformHandle = (
  transformHandle: TransformHandle,
  x: number,
  y: number,
  isRotate = false
) =>
{
  let OFFSET_SIZE = 0;
  if (isRotate){
    OFFSET_SIZE = 8;
  }

  return x >= transformHandle[0]-OFFSET_SIZE &&
      x <= transformHandle[0] + transformHandle[2] + OFFSET_SIZE &&
      y >= transformHandle[1]-OFFSET_SIZE &&
      y <= transformHandle[1] + transformHandle[3]+OFFSET_SIZE;
}


const P_OFFSET = 10;
const P_OFFSET_2 = 20
const isInsideTransformHandleNew = (
    transformHandle: TransformHandle,
    x: number,
    y: number,
    element:any,
    key:string,
) =>{
  // if (isNoteElement(element) && !element.customData?.generationData?.isExpand){
  //   //折叠的note禁止拉伸......
  //   return false;
  // }

  if (key == 'se' || key == 'sw' || key == 'ne' || key == 'nw'){
    // if (isNoteElement(element) && !element.customData?.generationData?.isExpand){
    //   //折叠的note禁止拉伸......
    //   return false;
    // }

    if (x >= transformHandle[0] &&
        x <= transformHandle[0] + transformHandle[2] &&
        y >= transformHandle[1] &&
        y <= transformHandle[1] + transformHandle[3]){

      return true;
    }
    return false;
  }else{
    // if (isTextElement(element))return false;

    let n = false,s=false,e=false,w=false;
    if (key == 'n'){
      n = (xyInElementRect(x,y,element,key) && ((x >= (element.x) && x <= (element.x+element.width) && y>=(element.y-P_OFFSET) && y<(element.y+P_OFFSET))));
    }else if (key == 's'){
      s = xyInElementRect(x,y,element,key) && ((x >= (element.x - P_OFFSET) && x <= (element.x+element.width) && y>=(element.y+element.height-P_OFFSET) && y<(element.y+element.height+P_OFFSET)));
    }else if (key == 'e'){
      e = xyInElementRect(x,y,element,key) && ((x >= (element.x + element.width - P_OFFSET) && x <= (element.x+element.width+P_OFFSET) && y>=(element.y) && y<(element.y+element.height)));
    }else if (key == 'w'){
      w = xyInElementRect(x,y,element,key) && ((x >= (element.x - P_OFFSET) && x <= (element.x+P_OFFSET) && y>=(element.y) && y<(element.y+element.height)));
    }

    const isIn = n || s || e || w || isInsideTransformHandle(transformHandle,x,y);
    // console.log('isIn********',isIn);
    return isIn;
    // return xyInElementRect(x,y,element) && ((x >= transformHandle[0] &&
    //         x <= transformHandle[0] + transformHandle[2] && y>=element.y && y<(element.y+element.height)) ||
    //     (y >= transformHandle[1] &&
    //         y <= transformHandle[1] + transformHandle[3]) && x>=element.x && x<(element.x+element.width));
  }
}

/**
 * //上北下南左西右东。。。。。。。。//上北下南左西右东。。。。。。。。//上北下南左西右东。。。。。。。。//上北下南左西右东。。。。。。。。//上北下南左西右东。。。。。。。。//上北下南左西右东。。。。。。。。//上北下南左西右东。。。。。。。。
 * @param x
 * @param y
 * @param element
 * @param key
 */
const xyInCenter = (x:number,y:number,element:any,key:any)=>{
  const OFFSET = 10;
  let isInCenter = false;
  if (key == 'n'){//上北下南左西右东。。。。。。。。
    isInCenter = x>=(element.x+element.width/2-OFFSET) && x<(element.x + element.width/2 + OFFSET)  &&
        y>= (element.y-OFFSET) && y <= (element.y + OFFSET);
  }else if (key == 's'){
    isInCenter = x>=(element.x+element.width/2-OFFSET) && x<(element.x + element.width/2 + OFFSET)  &&
        y>= (element.y+element.height-OFFSET) && y <= (element.y + element.height + OFFSET);
  }else if (key == 'w'){
    isInCenter = x>=(element.x-OFFSET) && x<(element.x + OFFSET)  &&
        y>= (element.y+element.height/2-OFFSET) && y <= (element.y+ element.height/2 + OFFSET);
  }else if (key == 'e'){
    isInCenter = x>=(element.x + element.width -OFFSET) && x<(element.x + element.width + OFFSET)  &&
        y>= (element.y+element.height/2-OFFSET) && y <= (element.y+ element.height/2 + OFFSET);
  }

  return isInCenter;
}

/**
 * 点在矩形内
 * @param x
 * @param y
 * @param element
 */
const xyInElementRect = (x:number,y:number,element:any,key:any)=>{
  const OFFSET = 12;
  return x>=(element.x-OFFSET) && x<(element.x + element.width + OFFSET)  && y>= (element.y-OFFSET) && y <= (element.y + element.height + OFFSET) && !xyInCenter(x,y,element,key)
}


export const resizeTest = (
  element: NonDeletedExcalidrawElement,
  appState: AppState,
  x: number,
  y: number,
  zoom: Zoom,
  pointerType: PointerType,
): MaybeTransformHandleType => {
  if (!appState.selectedElementIds[element.id]) {
    return false;
  }

  const { rotation: rotationTransformHandle, ...transformHandles } =
    getTransformHandles(element, zoom, pointerType);

  if (
    rotationTransformHandle &&
    isInsideTransformHandle(rotationTransformHandle, x, y,true)
  ) {
    if (!hasElementRotate(element))return false;
    return "rotation" as TransformHandleType;
  }

  const filter = Object.keys(transformHandles).filter((key) => {
    const transformHandle =
      transformHandles[key as Exclude<TransformHandleType, "rotation">]!;
    if (!transformHandle) {
      return false;
    }
    return isInsideTransformHandleNew(transformHandle, x, y,element,key);
  });

  if (filter.length > 0) {
    return filter[0] as TransformHandleType;
  }

  return false;
};

export const getElementWithTransformHandleType = (
  elements: readonly NonDeletedExcalidrawElement[],
  appState: AppState,
  scenePointerX: number,
  scenePointerY: number,
  zoom: Zoom,
  pointerType: PointerType,
) => {
  return elements.reduce((result, element) => {
    if (result) {
      return result;
    }
    const transformHandleType = resizeTest(
      element,
      appState,
      scenePointerX,
      scenePointerY,
      zoom,
      pointerType,
    );
    return transformHandleType ? { element, transformHandleType } : null;
  }, null as { element: NonDeletedExcalidrawElement; transformHandleType: MaybeTransformHandleType } | null);
};

// 获取四个复制按钮的
const getQuickFlowHandlesFromCoords = ({
                                         element,
                                         scenePointerX,
                                         scenePointerY,
                                         appState,
                                       }: {
  element: NonDeletedExcalidrawElement;
  scenePointerX: number;
  scenePointerY: number;
  appState: AppState;
}): ElementWithQuickFlowHandle | false => {
  const quickFlowHandles = getQuickFlowHandles({
    element,
    appState,
    size: 18,
  });
  const quickFlowHandlesArray = Object.entries(quickFlowHandles);

  for (let i = 0; i < quickFlowHandlesArray.length; i++) {
    const [key, value] = quickFlowHandlesArray[i];
    if (value) {
      const { x, y, width, height } = value;

      const range = [x, y, x + width, y + height];
      const isHitAuxiliaryHandle =
          scenePointerX > range[0] &&
          scenePointerX < range[2] &&
          scenePointerY > range[1] &&
          scenePointerY < range[3];

      if (isHitAuxiliaryHandle) {
        return {
          direction: key as ConnectionDirection,
          quickFlowHandle: value,
          element,
        };
      }
    }
  }
  return false;
};

const getHoverHandlesFromCoords = ({
                                     element,
                                     scenePointerX,
                                     scenePointerY,
                                     appState,
                                   }: {
  element: NonDeletedExcalidrawElement;
  scenePointerX: number;
  scenePointerY: number;
  appState: AppState;
}): ElementWithHoverHandle | false => {
  const hoverHandles = getHoverHandles({
    element,
    appState,
    size: 18,
  });
  const hoverHandlesArray = Object.entries(hoverHandles);

  for (let i = 0; i < hoverHandlesArray.length; i++) {
    const [key, value] = hoverHandlesArray[i];
    if (key !== appState.hoveredElement.direction) {
      continue;
    }

    if (value) {
      const { x, y, width, height } = value;
      const [pointerX, pointerY] = rotate(
          scenePointerX,
          scenePointerY,
          element.x + element.width / 2,
          element.y + element.height / 2,
          -element.angle,
      );
      const range = [x, y, x + width, y + height];
      const isHitAuxiliaryHandle =
          pointerX > range[0] &&
          pointerX < range[2] &&
          pointerY > range[1] &&
          pointerY < range[3];

      if (isHitAuxiliaryHandle) {
        return {
          direction: key as ConnectionDirection,
          hoverHandle: value,
          element,
        };
      }
    }
  }
  return false;
};

export const getHoverHandles = ({
                                  element,
                                  appState,
                                  size,
                                }: {
  element: NonDeletedExcalidrawElement;
  appState: InteractiveCanvasAppState;
  size: number;
}) => {
  const DEFAULT_QUICKFLOW_SPACING = 0;
  const centerX = element.x + element.width / 2;
  const centerY = element.y + element.height / 2;

  //修正UI上不好处理的偏移
  let nRightOffset = 0;
  let nBottomOffset = 0;
  if (isNoteElement(element)){
    if (appState.selectedElementIds[element.id]){
      nRightOffset = 2/appState.zoom.value;
    }
    nBottomOffset = 2/appState.zoom.value;
  }

  const halfSize = size / 2;
  const hoverHandles = {
    top: {
      x: centerX - halfSize,
      y:
          element.y -
          (DEFAULT_QUICKFLOW_SPACING + halfSize) /
          (appState.zoom.value > 1 ? 1 : appState.zoom.value),
      width: size / (appState.zoom.value > 1 ? 1 : appState.zoom.value),
      height: size / (appState.zoom.value > 1 ? 1 : appState.zoom.value),
      quickFlowImage: QUICKFLOW_TOP_IMG,
    },
    right: {
      x:
          nRightOffset +
          element.x +
          element.width +
          (DEFAULT_QUICKFLOW_SPACING - halfSize) /
          (appState.zoom.value > 1 ? 1 : appState.zoom.value),
      y: centerY - halfSize,
      width: size / (appState.zoom.value > 1 ? 1 : appState.zoom.value),
      height: size / (appState.zoom.value > 1 ? 1 : appState.zoom.value),
      quickFlowImage: QUICKFLOW_RIGHT_IMG,
    },
    bottom: {
      x: centerX - halfSize,
      y:
          nBottomOffset +
          element.y +
          element.height +
          (DEFAULT_QUICKFLOW_SPACING - halfSize) /
          (appState.zoom.value > 1 ? 1 : appState.zoom.value),
      width: size / (appState.zoom.value > 1 ? 1 : appState.zoom.value),
      height: size / (appState.zoom.value > 1 ? 1 : appState.zoom.value),
      quickFlowImage: QUICKFLOW_BOTTOM_IMG,
    },
    left: {
      x:
          element.x -
          (DEFAULT_QUICKFLOW_SPACING + halfSize) /
          (appState.zoom.value > 1 ? 1 : appState.zoom.value),
      y: centerY - halfSize,
      width: size / (appState.zoom.value > 1 ? 1 : appState.zoom.value),
      height: size / (appState.zoom.value > 1 ? 1 : appState.zoom.value),
      quickFlowImage: QUICKFLOW_LEFT_IMG,
    },
  };
  return hoverHandles;
};

export const getQuickFlowHandles = ({
                                      element,
                                      appState,
                                      size,
                                    }: {
  element: NonDeletedExcalidrawElement;
  appState: InteractiveCanvasAppState;
  size: number;
}) => {
  const centerX = element.x + element.width / 2;
  const centerY = element.y + element.height / 2;

  const halfSize = size / 2;
  const quickFlowHandles = {
    top: {
      x: centerX - halfSize,
      y:
          element.y -
          (DEFAULT_QUICKFLOW_SPACING + halfSize) /
          (appState.zoom.value > 1 ? 1 : appState.zoom.value),
      width: size / (appState.zoom.value > 1 ? 1 : appState.zoom.value),
      height: size / (appState.zoom.value > 1 ? 1 : appState.zoom.value),
      quickFlowImage: QUICKFLOW_TOP_IMG,
    },
    right: {
      x:
          element.x +
          element.width +
          (DEFAULT_QUICKFLOW_SPACING - halfSize) /
          (appState.zoom.value > 1 ? 1 : appState.zoom.value),
      y: centerY - halfSize,
      width: size / (appState.zoom.value > 1 ? 1 : appState.zoom.value),
      height: size / (appState.zoom.value > 1 ? 1 : appState.zoom.value),
      quickFlowImage: QUICKFLOW_RIGHT_IMG,
    },
    bottom: {
      x: centerX - halfSize,
      y:
          element.y +
          element.height +
          (DEFAULT_QUICKFLOW_SPACING - halfSize) /
          (appState.zoom.value > 1 ? 1 : appState.zoom.value),
      width: size / (appState.zoom.value > 1 ? 1 : appState.zoom.value),
      height: size / (appState.zoom.value > 1 ? 1 : appState.zoom.value),
      quickFlowImage: QUICKFLOW_BOTTOM_IMG,
    },
    left: {
      x:
          element.x -
          (DEFAULT_QUICKFLOW_SPACING + halfSize) /
          (appState.zoom.value > 1 ? 1 : appState.zoom.value),
      y: centerY - halfSize,
      width: size / (appState.zoom.value > 1 ? 1 : appState.zoom.value),
      height: size / (appState.zoom.value > 1 ? 1 : appState.zoom.value),
      quickFlowImage: QUICKFLOW_LEFT_IMG,
    },
  };
  return quickFlowHandles;
};

export const getElementWithQuickFlowHandles = ({
                                                 element,
                                                 appState,
                                                 scenePointerX,
                                                 scenePointerY,
                                                 zoom,
                                                 pointerType,
                                               }: {
  element: NonDeletedExcalidrawElement;
  appState: AppState;
  scenePointerX: number;
  scenePointerY: number;
  zoom: Zoom;
  pointerType: PointerType;
}) => {
  const hitAuxiliaryHandle = getQuickFlowHandlesFromCoords({
    element,
    scenePointerX,
    scenePointerY,
    appState,
  });

  return hitAuxiliaryHandle;
};

export const getElementWithHoverHandles = ({
                                             element,
                                             appState,
                                             scenePointerX,
                                             scenePointerY,
                                           }: {
  element: NonDeletedExcalidrawElement;
  appState: AppState;
  scenePointerX: number;
  scenePointerY: number;
}) => {
  const hitAuxiliaryHandle = getHoverHandlesFromCoords({
    element,
    scenePointerX,
    scenePointerY,
    appState,
  });

  return hitAuxiliaryHandle;
};

let IS_QUICKFLOW_TOOLTIP_VISIBLE = false;
let QUICKFLOW_TOOLTIP_TIMEOUT_ID: number | null = null;
export const showQuickFlowTooltip = (
    element: NonDeletedExcalidrawElement,
    appState: AppState,
    elementWithQuickFlowHandle: ElementWithQuickFlowHandle | false,
) => {
  if (elementWithQuickFlowHandle === false) {
    return;
  }
  if (QUICKFLOW_TOOLTIP_TIMEOUT_ID) {
    clearTimeout(QUICKFLOW_TOOLTIP_TIMEOUT_ID);
  }
  QUICKFLOW_TOOLTIP_TIMEOUT_ID = window.setTimeout(
      () => renderTooltip(element, appState, elementWithQuickFlowHandle),
      QUICKFLOW__TOOLTIP_DELAY,
  );
};
export const hideQuickFlowToolip = () => {
  if (QUICKFLOW_TOOLTIP_TIMEOUT_ID) {
    clearTimeout(QUICKFLOW_TOOLTIP_TIMEOUT_ID);
  }
  if (IS_QUICKFLOW_TOOLTIP_VISIBLE) {
    IS_QUICKFLOW_TOOLTIP_VISIBLE = false;
    getTooltipDiv().classList.remove("excalidraw-tooltip--visible");
  }
};

const renderTooltip = (
    element: NonDeletedExcalidrawElement,
    appState: AppState,
    elementWithQuickFlowHandle: ElementWithQuickFlowHandle,
) => {
  // 创建或获取工具提示框的DOM元素
  const tooltipDiv = getTooltipDiv();

  // 设置工具提示框的样式和可见性
  tooltipDiv.classList.add("excalidraw-tooltip--visible");
  tooltipDiv.style.maxWidth = "20rem";
  tooltipDiv.textContent = "Add subtopic"; // 将元素的链接文本设置为工具提示的内容

  const coordsValue = elementWithQuickFlowHandle.quickFlowHandle;

  // 将场景坐标转换为视口坐标
  const viewportCoords = sceneCoordsToViewportCoords(
      { sceneX: coordsValue.x, sceneY: coordsValue.y },
      appState,
  );

  // 更新工具提示框的位置，使其指向链接把手
  updateTooltipPosition(
      tooltipDiv,
      {
        left: viewportCoords.x,
        top: viewportCoords.y,
        width: coordsValue.width,
        height: coordsValue.height,
      },
      "top",
  );

  // 跟踪事件：点击了链接图标
  trackEvent("hyperlink", "tooltip", "link-icon");

  // 标记快速流程工具提示可见
  IS_QUICKFLOW_TOOLTIP_VISIBLE = true;
};

export const getTransformHandleTypeFromCoords = (
  [x1, y1, x2, y2]: Bounds,
  scenePointerX: number,
  scenePointerY: number,
  zoom: Zoom,
  pointerType: PointerType,
): MaybeTransformHandleType => {
  const transformHandles = getTransformHandlesFromCoords(
    [x1, y1, x2, y2, (x1 + x2) / 2, (y1 + y2) / 2],
    0,
    zoom,
    pointerType,
    OMIT_SIDES_FOR_MULTIPLE_ELEMENTS,
  );

  const found = Object.keys(transformHandles).find((key) => {
    const transformHandle =
      transformHandles[key as Exclude<TransformHandleType, "rotation">]!;
    return (
      transformHandle &&
      isInsideTransformHandle(transformHandle, scenePointerX, scenePointerY,true)
    );
  });
  return (found || false) as MaybeTransformHandleType;
};

const RESIZE_CURSORS = ["ns", "nesw", "ew", "nwse"];
const rotateResizeCursor = (cursor: string, angle: number) => {
  const index = RESIZE_CURSORS.indexOf(cursor);
  if (index >= 0) {
    const a = Math.round(angle / (Math.PI / 4));
    cursor = RESIZE_CURSORS[(index + a) % RESIZE_CURSORS.length];
  }
  return cursor;
};

/*
 * Returns bi-directional cursor for the element being resized
 */
export const getCursorForResizingElement = (resizingElement: {
  element?: ExcalidrawElement;
  transformHandleType: MaybeTransformHandleType;
}): string => {
  const { element, transformHandleType } = resizingElement;
  const shouldSwapCursors =
    element && Math.sign(element.height) * Math.sign(element.width) === -1;
  let cursor = null;

  switch (transformHandleType) {
    case "n":
    case "s":
      cursor = "ns";
      break;
    case "w":
    case "e":
      cursor = "ew";
      break;
    case "nw":
    case "se":
      if (shouldSwapCursors) {
        cursor = "nesw";
      } else {
        cursor = "nwse";
      }
      break;
    case "ne":
    case "sw":
      if (shouldSwapCursors) {
        cursor = "nwse";
      } else {
        cursor = "nesw";
      }
      break;
    case "rotation":
      return "grab";
  }

  if (cursor && element) {
    cursor = rotateResizeCursor(cursor, element.angle);
  }

  return cursor ? `${cursor}-resize` : "";
};
